'use strict';

var naPhone = /^\(?([2-9][0-8][0-9])\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
    phone: {
        us: naPhone,
        ca: naPhone,
        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
        it: /^(([0-9]{2,4})([-\s/]{0,1})([0-9]{4,8}))?$/,
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/,
        se: /^\+[0-9]{1}[0-9]{3,14}$/,
        dk: /^\+[0-9]{1}[0-9]{3,14}$/,
        no: /^\+[0-9]{1}[0-9]{3,14}$/,
        fi: /^\+[0-9]{1}[0-9]{3,14}$/
    },
    postal: {
        us: /^\d{5}(-\d{4})?$/,
        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
        it: /^([0-9]){5}$/,
        jp: /^([0-9]){3}[-]([0-9]){4}$/,
        cn: /^([0-9]){6}$/,
        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/,
        se: /^\d{3} *\d{2}$/,
        dk: /^\d{4}$/,
        no: /^\d{4}$/,
        fi: /^\d{5}$/
    },
    notCC: /^(?!(([0-9 -]){13,19})).*$/
};
// global form validator settings
var settings = {
    errorClass: 'error-message c-form-row__error-message',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
        if (!this.checkable(element)) {
            this.element(element);
        }
    },

    // Toggle has-error class on form-row
    highlight: function(element) {
        var $formRow = $(element).closest('.form-row, .c-form-row');
        $formRow.removeClass('is-ss-validated').addClass('has-error')
            .find('.error-message.is-ss-error-message').remove();
    },
    unhighlight: function(element) {
        var $formRow = $(element).closest('.form-row, .c-form-row');
        $formRow.not('.is-ss-validated')
            .removeClass('has-error')
            .find('.error-message.is-ss-error-message').remove();
    }
};
/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
    var country = $(el).closest('form').find('.country');
    if (country.length === 0 || country.val().length === 0 || !regex.phone[country.val().toLowerCase()]) {
        return true;
    }

    var rgx = regex.phone[country.val().toLowerCase()];
    var isOptional = this.optional(el);
    var isValid = rgx.test($.trim(value));

    return isOptional || isValid;
};

/**
 * @function
 * @description Validates a given postalCode against the countries postalCode regex
 * @param {String} value The postalCode which will be validated
 * @param {String} el The input field
 */
var validatePostalCode = function (value, el) {
    var country = $(el).closest('form').find('.country');
    if (country.length === 0 || country.val().length === 0 || !regex.postal[country.val().toLowerCase()]) {
        return true;
    }

    var rgx = regex.postal[country.val().toLowerCase()];
    var isOptional = this.optional(el);
    var isValid = rgx.test($.trim(value));

    return isOptional || isValid;
};


/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
    var isValid = regex.notCC.test($.trim(value));
    return isValid;
};

/**
 * @function
 * @description Validates that if havereceipt field has value yes or no, yes is the valid value
 * @param {String} value The owner field which will be validated
 */
var validateHaveReceiptField = function (value) {
    var isValid = true;
    if (value === 'No') {
        isValid = false;
    }
    return isValid;
};

/**
 * @function
 * @description Validates that the date is in mm/dd/yyyy format and less than one year from today
 * @param {String} value The date field which will be validated
 * @param {String} el The input field
 */
var validateDate = function (value) {
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/ ;
    var isValid = date_regex.test(value);

    // determine if purchase date is less than 1 year ago
    if (isValid) {
        var dateString = value.split('/');
        var datePurchased = new Date(dateString[2], dateString[0] -1, dateString[1]);
        var dateNow = new Date();
        var elapsedDays = Math.round((dateNow-datePurchased)/(1000*60*60*24));
        if (elapsedDays > 366) {
            isValid = false;
        }
    }

    return isValid;
};

var consumerStickAllowedDays = null;
var customStickAllowedDays = null;
var stickWarrantyConfigPromise = null;

function getWarrantyConfigUrl() {
    var warrantyConfigUrl = window.Urls && window.Urls.warrantyConfig;

    if (warrantyConfigUrl && warrantyConfigUrl.indexOf('http') === 0) {
        return warrantyConfigUrl;
    }

    var warrantyApiUrl = window.Urls && (
        window.Urls.stickModelFlexPattern ||
        window.Urls.submitClaim ||
        window.Urls.findOrder
    );

    if (warrantyApiUrl) {
        try {
            return new URL(warrantyApiUrl, window.location.origin).origin + '/api/config';
        } catch (error) {
            // fall through to default
        }
    }

    return 'https://app.bauerwarranty.com/api/config';
}

function parseWarrantyConfig(configItems) {
    var config = {};

    if (!Array.isArray(configItems)) {
        return config;
    }

    configItems.forEach(function (item) {
        if (item && item.name) {
            config[item.name] = parseInt(item.value, 10);
        }
    });

    return config;
}

function getAllowedDays(config, offsetName) {
    var warrantyPeriod = config.warranty_period;
    var warrantyOffset = config[offsetName];

    if (isNaN(warrantyPeriod) || isNaN(warrantyOffset)) {
        return null;
    }

    return warrantyPeriod + warrantyOffset;
}

function applyWarrantyConfig(configItems) {
    var config = parseWarrantyConfig(configItems);
    consumerStickAllowedDays = getAllowedDays(config, 'warranty_offset_standard');
    customStickAllowedDays = getAllowedDays(config, 'warranty_offset_custom');

    if (customStickAllowedDays === null) {
        customStickAllowedDays = consumerStickAllowedDays;
    }

    window.StickWarrantyAllowedDays = {
        standard: consumerStickAllowedDays,
        custom: customStickAllowedDays
    };
}

function parseStickPurchaseDate(value) {
    if (!value) {
        return null;
    }

    var dateRegex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/((?:19|20)\d{2})$/;
    var match = String(value).match(dateRegex);

    if (match) {
        return new Date(Number(match[3]), Number(match[1]) - 1, Number(match[2]));
    }

    var isoMatch = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
        return new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]));
    }

    var parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
        return null;
    }

    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

function getElapsedCalendarDays(value) {
    var datePurchased = parseStickPurchaseDate(value);

    if (!datePurchased) {
        return null;
    }

    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    return Math.round((today - datePurchased) / (1000 * 60 * 60 * 24));
}

function isStickPurchaseDateEligible(value, allowedDays) {
    if (allowedDays === null || allowedDays === undefined) {
        return false;
    }

    var elapsedDays = getElapsedCalendarDays(value);

    if (elapsedDays === null) {
        return false;
    }

    return elapsedDays >= 0 && elapsedDays <= allowedDays;
}

window.isStickPurchaseDateEligible = isStickPurchaseDateEligible;

function loadWarrantyConfig() {
    if (stickWarrantyConfigPromise) {
        return stickWarrantyConfigPromise;
    }

    if (window.StickWarrantyConfigPromise) {
        stickWarrantyConfigPromise = window.StickWarrantyConfigPromise
            .then(function (configItems) {
                applyWarrantyConfig(configItems);
            });
        return stickWarrantyConfigPromise;
    }

    stickWarrantyConfigPromise = fetch(getWarrantyConfigUrl())
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Failed to load warranty config');
            }

            return response.json();
        })
        .then(function (configItems) {
            applyWarrantyConfig(configItems);
        });

    return stickWarrantyConfigPromise;
}

/**
 * @function
 * @description Validates that the date is in mm/dd/yyyy format and within the configured warranty window
 * @param {String} value The date field which will be validated
 * @param {String} el The input field
 */
var validateConsumerStickDate = function (value) {
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/ ;

    if (!date_regex.test(value)) {
        return false;
    }

    return isStickPurchaseDateEligible(value, consumerStickAllowedDays);
};

/**
 * @function
 * @description Validates that the date is in mm/dd/yyyy format and less than one year from today
 * @param {String} value The date field which will be validated
 * @param {String} el The input field
 */
var validateRetailerStickDate = function (value) {
    var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/ ;
    var isValid = date_regex.test(value);

    // determine if purchase date is less than 1 year ago
    if (isValid) {
        var dateString = value.split('/');
        var datePurchased = new Date(dateString[2], dateString[0] -1, dateString[1]);
        var dateNow = new Date();
        var elapsedDays = Math.round((dateNow-datePurchased)/(1000*60*60*24));
        //if (elapsedDays > SitePreferences.STICKVALIDATION) {
        //isValid = false;
        //}
        if (elapsedDays <= 0) {
            isValid = false;
        }
    }

    return isValid;
};

/**
 * @function
 * @description Validates that the address line 1 and address line 2 is less then 35 characters
 * @param {String} value The date field which will be validated
 * @param {String} el The input field
 */
var validateAddress = function (value) {
    var isValid = true;

    if(value !== '' && value !== undefined && value.length > 35){
        isValid = false;
    }
    return isValid;
};

/**
 * @function
 * @description Validates that the house/suite number only contains letters, numbers and hyphens
 * @param {String} value The house/suite number field which will be validated
 */
var validateHouseSuiteNumber = function (value) {
    var isValid = true;

    if (value !== '' && value !== undefined && !/^[a-zA-Z0-9-]*$/.test(value)) {
        isValid = false;
    }
    return isValid;
};

var validateStoreLocation = function (value) {
    var notAllowedStoreAddress = new RegExp('pure|pro hockey|sportchek|canadian|tire|national|dicks|prohockey|pro-hockey|sport chek|sport-chek|pernai|bobperani|bob perani|preranibob|prerani bob|peranis|bobperanis|bob peranis|preranisbob|preranis bob');
    var isValid = true;

    if(notAllowedStoreAddress.test(value.toLowerCase())){
        isValid = false;
    }

    return isValid;
};

var validateAddressPoBoxes = function (value) {
    var notAllowedAddress = new RegExp('box|apo|p.o|pobox|p.o.box|p.o box|p.o. box');
    var isValid = true;

    if(notAllowedAddress.test(value.toLowerCase())){
        isValid = false;
    }

    return isValid;
};

/**
 * @function
 * @description Validates that the email address is correct
 * @param {String} value The email field which will be validated
 * @param {String} el The input field
 */
var validateConfirmEmail = function (value, el) {
    var isValid = true;
    var email = $(el).closest('form').find('input[name$="_email"]');

    if ($.trim(email.val()) !== $.trim(value)) {
        isValid = false;
    }

    return isValid;
};

/**
 * @function
 * @description Validates that the email address is correct
 * @param {String} value The email field which will be validated
 * @param {String} el The input field
 */
var validateBillingConfirmEmail = function (value, el) {
    var isValid = true;
    var email = $(el).closest('form').find('input[name$="_emailAddress"]');

    if ($.trim(email.val()) !== $.trim(value)) {
        isValid = false;
    }

    return isValid;
};

/**
 * @function
 * @description Validates that the password
 * @param {String} value The password field which will be validated
 * @param {String} el The input field
 */
var validatePassword = function (value) {
    var password_regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,255}$/;
    var isValid = password_regex.test(value);

    return isValid;
};

function addMethods() {
    /**
     * Add phone validation method to jQuery validation plugin.
     * Text fields must have 'phone' css class to be validated as phone
     */
    $.validator.addMethod('phone', validatePhone, window.Resources.INVALID_PHONE);

    /**
     * Add CCOwner validation method to jQuery validation plugin.
     * Text fields must have 'owner' css class to be validated as not a credit card
     */
    $.validator.addMethod('owner', validateOwner, window.Resources.INVALID_OWNER);

    /**
     * Add havereceipt validation method to jQuery validation plugin.
     * Text fields must have 'havereceipt' css class to be validated as have receipt or not
     */
    $.validator.addMethod('havereceipt', validateHaveReceiptField, window.Resources.NO_RECEIPT);

    /**
     * Add date validation method to jQuery validation plugin.
     * Text fields must have 'datepurchased' css class to be validated
     */
    $.validator.addMethod('datepurchased', validateDate, window.Resources.INVALID_DATE);

    /**
     * Add store validation method to jQuery validation plugin.
     * Text fields must have 'stickpurchaselocation' css class to be validated
     */
    $.validator.addMethod('stickpurchaselocation', validateStoreLocation, window.Resources.INVALID_STORE_LOCATION);

    /**
     * Add address validation method to jQuery validation plugin.
     * Text fields must have 'poboxvalidate' css class to be validated
     */
     $.validator.addMethod('poboxvalidate', validateAddressPoBoxes, window.Resources.INVALID_ADDRESS_LOCATION);

    /**
     * Add date validation method to jQuery validation plugin.
     * Text fields must have 'datepurchased' css class to be validated
     */
    $.validator.addMethod('stickdatepurchased', validateConsumerStickDate, window.Resources.CONSUMER_INVALID_DATE);

    /**
     * Add date validation method to jQuery validation plugin.
     * Text fields must have 'datepurchased' css class to be validated
     */
    $.validator.addMethod('retialerdateofpurchased', validateRetailerStickDate, window.Resources.RETAILER_INVALID_DATE);

    /**
     * Add postalCode validation method to jQuery validation plugin.
     * Text fields must have 'postal' css class to be validated
     */
    $.validator.addMethod('postal', validatePostalCode, window.Resources.INVALID_POSTALCODE);

    /**
     * Add email confirmation validation method to jQuery validation plugin.
     * Text fields must have 'emailConfirm' css class to be validated
     */
    $.validator.addMethod('emailConfirm', validateConfirmEmail, window.Resources.VALIDATE_CONFIRMEMAIL);

    /**
     * Add email confirmation validation method to jQuery validation plugin.
     * Text fields must have 'billingEmailConfirm' css class to be validated
     */
    $.validator.addMethod('billingEmailConfirm', validateBillingConfirmEmail, window.Resources.VALIDATE_CONFIRMEMAIL);

    /**
     * Add password validation method to jQuery validation plugin.
     * Text fields must have 'password' css class to be validated
     */
    $.validator.addMethod('password', validatePassword, window.Resources.VALIDATE_PASSWORD);

    /**
     * Add validateAddress method to jQuery validation plugin.
     * Text fields must have 'emailConfirm' css class to be validated
     */
    $.validator.addMethod('addressline', validateAddress, window.Resources.VALIDATE_ADDRESS);

    /**
     * Add house/suite number validation method to jQuery validation plugin.
     * Text fields must have 'housesuitevalidate' css class to be validated
     */
    $.validator.addMethod('housesuitevalidate', validateHouseSuiteNumber, window.Resources.INVALID_HOUSE_SUITE_NUMBER);

    /**
     * Add gift cert amount validation method to jQuery validation plugin.
     * Text fields must have 'gift-cert-amont' css class to be validated
     */
    $.validator.addMethod('gift-cert-amount', function (value, el) {
        var isOptional = this.optional(el);
        var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
        return isOptional || isValid;
    }, window.Resources.GIFT_CERT_AMOUNT_INVALID);

    /**
     * Add positive number validation method to jQuery validation plugin.
     * Text fields must have 'positivenumber' css class to be validated as positivenumber
     */
    $.validator.addMethod('positivenumber', function (value) {
        if ($.trim(value).length === 0) { return true; }
        return (!isNaN(value) && Number(value) >= 0);
    }, ''); // '' should be replaced with error message if needed

    /**
    * Return true if the field value matches the given format RegExp
    *
    * @example $.validator.methods.pattern("AR1004",element,/^AR\d{4}$/)
    * @result true
    *
    * @example $.validator.methods.pattern("BR1004",element,/^AR\d{4}$/)
    * @result false
    *
    * @name $.validator.methods.pattern
    * @type Boolean
    * @cat Plugins/Validate/Methods
    */
    $.validator.addMethod( 'pattern', function( value, element, param ) {
        if ( this.optional( element ) ) {
            return true;
        }
        if ( typeof param === 'string' ) {
            param = new RegExp( '^(?:' + param + ')$' );
        }
        return param.test( value );
    }, 'Invalid format.' );


    $.extend($.validator.messages, {
        required: window.Resources.VALIDATE_REQUIRED,
        remote: window.Resources.VALIDATE_REMOTE,
        email: window.Resources.VALIDATE_EMAIL,
        url: window.Resources.VALIDATE_URL,
        date: window.Resources.VALIDATE_DATE,
        dateISO: window.Resources.VALIDATE_DATEISO,
        number: window.Resources.VALIDATE_NUMBER,
        digits: window.Resources.VALIDATE_DIGITS,
        creditcard: window.Resources.VALIDATE_CREDITCARD,
        equalTo: window.Resources.VALIDATE_EQUALTO,
        maxlength: $.validator.format(window.Resources.VALIDATE_MAXLENGTH),
        minlength: $.validator.format(window.Resources.VALIDATE_MINLENGTH),
        rangelength: $.validator.format(window.Resources.VALIDATE_RANGELENGTH),
        range: $.validator.format(window.Resources.VALIDATE_RANGE),
        max: $.validator.format(window.Resources.VALIDATE_MAX),
        min: $.validator.format(window.Resources.VALIDATE_MIN),
        pattern: window.Resources.VALIDATE_PATTERN
    });
}

// Initialize warranty form

function initStickWarrantyValidator() {
    var validator = {
        regex: regex,
        settings: settings,
        init: function () {
            var self = this;
            addMethods();
            $('form:not(.suppress)').each(function () {
                $(this).validate(self.settings);
            });
            $('.stickdatepurchased').each(function () {
                var $field = $(this);
                if ($field.val()) {
                    $field.valid();
                }
            });
        },
        initForm: function (f) {
            $(f).validate(this.settings);
        }
    };

    loadWarrantyConfig()
        .catch(function () {
            consumerStickAllowedDays = null;
        })
        .then(function () {
            validator.init();
        });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickWarrantyValidator);
} else {
    initStickWarrantyValidator();
}
